<template>
    <SfSection
        v-if="block.employees && block.employees.length"
    >
        <h2 v-if="block.sfTitle" class="sf-employees-block__title">
            {{ block.sfTitle }}
        </h2>

        <sf-employees-grid :employees="block.employees" />
    </SfSection>
</template>

<script>
import contentBlockMixin from '~/mixins/content-block';
import SfSection from '~/patterns/organisms/section/section';
import SfEmployeesGrid from '~/patterns/organisms/employees-grid/employees-grid';

export default {
    components: {
        SfSection,
        SfEmployeesGrid
    },

    mixins: [
        contentBlockMixin
    ]
};
</script>
